export enum Modals {
  Confirmation = 'CONFIRMATION_MODAL',
  AdminUserEdit = 'ADMIN_USER_EDIT_MODAL',
  ClaimSetCreation = 'CLAIM_SET_CREATION_MODAL',
  AddPotentialPolicy = 'ADD_POTENTIAL_POLICY_MODAL',
  StatusReason = 'STATUS_REASON_MODAL',
  ReportClaim = 'REPORT_CLAIM_MODAL',
  AddContact = 'ADD_CONTACT_MODAL',
  LinkPolicy = 'LINK_POLICY_MODAL',
  AddContactInfo = 'ADD_CONTACT_INFO_MODAL',
  AddAddress = 'ADD_ADDRESS_MODAL',
  UpdateAddress = 'UPDATE_ADDRESS_MODAL',
  AddPotentialBeneficiary = 'ADD_POTENTIAL_BENEFICIARY_MODAL',
  AddClaimant = 'ADD_CLAIMANT_MODAL',
  DocumentPreviewModal = 'DOCUMENT_PREVIEW_MODAL',
  AddTask = 'ADD_TASK_MODAL',
  AddCoverage = 'ADD_COVERAGE_MODAL',
  LinkCoverage = 'LINK_COVERAGE_MODAL',
  AddClaim = 'ADD_CLAIM_MODAL',
  Milestone = 'MILESTONE_MODAL',
  AddRequestedItem = 'ADD_REQUESTED_ITEM_MODAL',
  UpdateRequestedItem = 'UPDATE_REQUESTED_ITEM_MODAL',
  DeleteRequestedItem = 'DELETE_REQUESTED_ITEM_MODAL',
  AddInsured = 'ADD_INSURED_MODAL',
  AddCustomInbox = 'ADD_CUSTOM_INBOX_MODAL',
  AddPayment = 'ADD_PAYMENT_MODAL',
  AddPaymentMethod = 'ADD_PAYMENT_METHOD_MODAL',
  EditPaymentMethod = 'EDIT_PAYMENT_METHOD_MODAL',
  AddPaymentAdjustment = 'ADD_PAYMENT_ADJUSTMENT_MODAL',
  AddBenefitAdjustment = 'ADD_BENEFIT_ADJUSTMENT_MODAL',
  AddPayeeToPayment = 'ADD_PAYEE_TO_PAYMENT_MODAL',
  AddPayeeToPaymentAdjustment = 'ADD_PAYEE_TO_PAYMENT_ADJUSTMENT_MODAL',
  AddPayeeToBenefitAdjustment = 'ADD_PAYEE_TO_BENEFIT_ADJUSTMENT_MODAL',
  AddPaymentSplit = 'ADD_PAYMENT_SPLIT_MODAL',
  EditBenefitCalculation = 'EDIT_BENEFIT_CALCULATION_MODAL',
  OverrideBenefitCalculation = 'OVERRIDE_BENEFIT_CALCULATION_MODAL',
  DocumentGeneration = 'DOCUMENT_GENERATION_MODAL',
  Note = 'NOTE_MODAL',
  DocumentVersionHistory = 'DOCUMENT_VERSION_HISTORY_MODAL',
  DocumentStatusHistory = 'DOCUMENT_STATUS_HISTORY_MODAL',
  DocumentParametersAndVariables = 'DOCUMENT_PARAMETERS_AND_VARIABLES_MODAL',
  CorrespondenceStatusHistory = 'CORRESPONDENCE_STATUS_HISTORY_MODAL',
  PdfViewer = 'PDF_VIEWER_MODAL',
  EditAssignmentQueueAccount = 'EDIT_ASSIGNMENT_QUEUE_ACCOUNT_MODAL',
  AddAssignmentQueueAccount = 'ADD_ASSIGNMENT_QUEUE_ACCOUNT_MODAL',
  Correspondence = 'CORRESPONDENCE_MODAL',
  LinkProducer = 'LINK_PRODUCER_MODAL',
  DataTable = 'DATA_TABLE_MODAL',
  AddProducer = 'ADD_PRODUCER_MODAL',
}
